import { render, staticRenderFns } from "./SelectAndSearchContent.vue?vue&type=template&id=b0204d94"
import script from "./SelectAndSearchContent.vue?vue&type=script&lang=js"
export * from "./SelectAndSearchContent.vue?vue&type=script&lang=js"
import style0 from "./SelectAndSearchContent.vue?vue&type=style&index=0&id=b0204d94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports